import { Map, Construction } from 'lucide-react';

export function ProductRoadmap() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <div className="flex items-center space-x-3">
          <Map className="h-8 w-8 text-gray-400" />
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Product Roadmap</h1>
            <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
              Track the progress of features, bugs, and feedback across the product lifecycle
            </p>
          </div>
        </div>
      </div>

      {/* Coming Soon placeholder */}
      <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-12">
        <div className="flex flex-col items-center justify-center text-center">
          <div className="w-16 h-16 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mb-4">
            <Construction className="h-8 w-8 text-gray-400 dark:text-gray-500" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            Coming Soon
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-md">
            The Product Roadmap view is currently under development. Check back soon to see a visual overview of planned features and their progress.
          </p>
        </div>
      </div>
    </div>
  );
}
